import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Button from 'Components/UI/Button';
import { Icon } from 'Components/UI';
import Modal from 'Components/UI/Modal';
import styles from './AvisoUploadUpgrade.module.scss';

import PlanoAvisoObraUpgrade from 'Static/images/plano-aviso-obra-upgrade.png';

interface IAvisoObraUpgrade {
  visible?: boolean;
  onCancel?: () => void;
  onConfirm: () => void;
  order?: number;
  role?: number;
  planFree?: boolean;
  limitUpload?: number;
}

const AvisoUploadUpgrade: FC<IAvisoObraUpgrade> = ({
  visible,
  onCancel,
  onConfirm,
  role,
  planFree,
  limitUpload,
}) => {
  const { t } = useTranslation('listagemArquivos');

  return (
    <Modal
      footerButtons={false}
      visible={visible}
      width={'auto'}
      onCancel={onCancel}
    >
      <div className={styles['wrapper']}>
        <div className={styles['imageWrapper']}>
          <img src={PlanoAvisoObraUpgrade}></img>
        </div>
        <div className={`${styles['contentWrapper']} ${!planFree ? styles['contentWrapperPro'] : ''}`}>
          <div>
            <label className={styles['avisoLimiteObras']}>
              {t('avisoUploadUpgrade.limitAlert', { limit: limitUpload ?? 10 })}
            </label>
          </div>
          <h2>
            {role === 1
              ? t('avisoUploadUpgrade.upgradePersonal')
              : t('avisoUploadUpgrade.upgradeCompany')
            }
          </h2>
          <h3>{t('avisoUploadUpgrade.forUnlimited')}</h3>
          {planFree && <>
            <p>{t('avisoUploadUpgrade.premiumOffers')}</p>
            <div className={styles['icons-wrapper']}>
              <div className={`${styles['icons-text-wrapper']} ${styles['icons-text-margin']}`}>
                <div>
                  <Icon icon={'arquivo3d'} size={'xs'} customColor={'#8697A8'} style={{ paddingLeft: 0, marginLeft: 0 }} />
                  <span>{t('avisoUploadUpgrade.docManagement')}</span>
                </div>
                <div>
                  <Icon icon={'estrelaVazia'} size={'xs'} customColor={'#8697A8'} style={{ paddingLeft: 0, marginLeft: 0 }} />
                  <span>{t('avisoUploadUpgrade.nomenclatureControl')}</span>
                </div>
              </div>
              <div className={styles['icons-text-wrapper']}>
                <div>
                  <Icon icon={'menuGerenciarUsuario'} size={'xs'} customColor={'#8697A8'} />
                  <span>{t('avisoUploadUpgrade.userManagement')}</span>
                </div>
                <div>
                  <Icon icon={'menuPlotagem'} size={'xs'} customColor={'#8697A8'} />
                  <span>{t('avisoUploadUpgrade.plottingControl')}</span>
                </div>
              </div>
              <div style={{ marginBottom: 14 }}>&nbsp;</div>
            </div>
          </>}

          <div className={styles['button-wrapper']}>
            <Button className={styles['button-cancel']} type='link' width={190} height={48} onClick={onCancel}>
              {t('avisoUploadUpgrade.maybeLater')}
            </Button>

            <Button
              className={styles['button-confirm']}
              type='primary'
              ispremium="true"
              width={287}
              height={48}
              onClick={() => onConfirm()}
            >
              <Icon icon="crown" className={styles['icon']} size="xxs" color="cinzaEscuro" />
              {role === 1
                ? t('avisoUploadUpgrade.getPremium')
                : t('avisoUploadUpgrade.requestPremium')
              }
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AvisoUploadUpgrade;
